import { ServiceRecord } from '../types';
import { formatDate } from './formatters';

export function buildDeviceLine(brand?: string | null, model?: string | null, deviceType?: string | null): String {
  const parts = [brand?.trim(), model?.trim()].filter((p): p is string => Boolean(p && p.length > 0));
  if (parts.length > 0) {
    return parts.join(' ');
  }
  return deviceType?.trim() || 'Urządzenie';
}

/**
 * Buduje tekst potwierdzenia przyjęcia dla klienta z 100% zgodnością z Android MessageSender.kt.
 */
export function buildIntakeText(record: ServiceRecord, customMessage?: string): string {
  const deviceLine = buildDeviceLine(record.brand, record.model, record.deviceType);
  const intakeDate = formatDate(record.createdAt);
  
  const lines: string[] = [
    'MAdKuM - potwierdzenie przyjęcia sprzętu',
    '',
    `Nr zgłoszenia: ${record.ticketNumber}`,
    `Data przyjęcia: ${intakeDate}`,
    `Urządzenie: ${deviceLine}`,
  ];

  if (record.description && record.description.trim().length > 0) {
    lines.push(`Opis: ${record.description.trim()}`);
  }
  if (record.visualCondition && record.visualCondition.trim().length > 0) {
    lines.push(`Stan przy przyjęciu: ${record.visualCondition.trim()}`);
  }

  lines.push('');
  lines.push('Potwierdzam przyjęcie urządzenia do serwisu.');

  if (customMessage && customMessage.trim().length > 0) {
    lines.push('');
    lines.push(customMessage.trim());
  }

  return lines.join('\n');
}

/**
 * Buduje tekst aktualizacji naprawy dla klienta.
 */
export function buildRepairUpdateText(record: ServiceRecord, customMessage?: string): string {
  const deviceLine = buildDeviceLine(record.brand, record.model, record.deviceType);
  const currentDate = formatDate(Date.now());
  const bodyText = customMessage && customMessage.trim().length > 0
    ? customMessage.trim()
    : 'Przesyłam aktualizację dotyczącą naprawy urządzenia.';

  return [
    'MAdKuM - aktualizacja naprawy',
    '',
    `Nr zgłoszenia: ${record.ticketNumber}`,
    `Data: ${currentDate}`,
    `Urządzenie: ${deviceLine}`,
    '',
    bodyText,
  ].join('\n');
}

/**
 * Buduje tekst informacji o zakończeniu naprawy (gotowe do odbioru).
 */
export function buildCompletionText(record: ServiceRecord, customMessage?: string): string {
  const deviceLine = buildDeviceLine(record.brand, record.model, record.deviceType);
  const currentDate = formatDate(Date.now());

  const lines: string[] = [
    'MAdKuM - naprawa zakończona',
    '',
    `Nr zgłoszenia: ${record.ticketNumber}`,
    `Data: ${currentDate}`,
    `Urządzenie: ${deviceLine}`,
    '',
    'Naprawa została zakończona. Urządzenie jest gotowe do odbioru.',
  ];

  if (customMessage && customMessage.trim().length > 0) {
    lines.push('');
    lines.push(customMessage.trim());
  }

  return lines.join('\n');
}
